import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import FormControl from "@mui/material/FormControl";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { Button } from "@material-tailwind/react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { MyDomain } from "../../App";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Phone } from "@mui/icons-material";
import dayjs from "dayjs";
import CheckOutPersonalInfoDeliveryBlock from "./CheckOutPersonalInfoDeliveryBlock";
import CheckOutPersonalInfoBlock from "./CheckOutPersonalInfoBlock";
import { useTranslation } from "react-i18next";
const label = { inputProps: { "aria-label": "Checkbox demo" } };

export default function CheckOutPersonalInfo({
  onAction,
  OBJForCheckOutDeliveryDetails,
  setOBJForCheckOutDeliveryDetails,
}) {
  const { t, i18n } = useTranslation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    //handleClearSpecificItem();
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: windowWidth <= 1024 ? "column" : "row",
        width: "100%",
        justifyContent: "space-between",
        position: "relative",
      }}
    >
      <>
        <CheckOutPersonalInfoBlock />
      </>
      <>
        <CheckOutPersonalInfoDeliveryBlock
          onAction={onAction}
          OBJForCheckOutDeliveryDetails={OBJForCheckOutDeliveryDetails}
          setOBJForCheckOutDeliveryDetails={setOBJForCheckOutDeliveryDetails}
        />
      </>
    </div>
  );
}
